import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useApi } from "../Context/ApiProvider";
import { Divider, Spinner } from "@nextui-org/react";

export function Brand({ image }) {
  return (
    <Link className="cursor-pointer ">
      <div className="transition-colors hover:bg-primary-10 w-full bg-white rounded-lg h-36  lg:h-52 p-5 sm:p-14 md:p-5 shadow-md flex items-center justify-center border border-black  overflow-hidden mb-4">
        <img className=" w-full xl:p-10 " src={image} alt="brand" />
      </div>
    </Link>
  );
}

const OurBrand = () => {
  const [brands, setBrands] = useState([]);
  const { t } = useTranslation();
  const api = useApi();
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    (async () => {
      setLoadingPage(true);

      const resBrands = await api.uget("/api/shop/brands?");

      if (resBrands.ok && resBrands.body && resBrands.body.results) {
        const fetchedBrands = resBrands.body.results.map((brand) => ({
          id: brand.id,
          title: brand.title,
          image: brand.image ? brand.image.url : null,
        }));
        setBrands(fetchedBrands);
      }
      setLoadingPage(false);
    })();
  }, [api]);

  return (
    <>
      {loadingPage ? (
        <Spinner size="lg" className="flex justify-center mt-80 " />
      ) : (
        <section
          className="grid grid-cols-1 mt-10 lg:mt-0 md:h-[35rem]
        rem] bg-green-900 bg-opacity-65  "
        >
          <div className="flex flex-col items-center justify-center ">
            <h2 className="font-bold text-4xl mt-5 lg:mt-0 ">
              {t("ourbrandtitle")}
            </h2>
            <Divider className="bg-red-600 h-1  w-40 lg:w-64   mt-3" />
          </div>

          {/* Brand display grid */}
          <div className="grid grid-cols-2  md:grid-cols-4  gap-6 mt-10 w-[80%] m-auto">
            {brands.map((brand) => (
              <Brand key={brand.id} image={brand.image} />
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default OurBrand;
